import { TrustedCustomer } from 'types';

import { createCrudApi } from './crud.api';

export const trustedCustomersApi =
  createCrudApi<TrustedCustomer>('/trusted-customers');
